import { render, staticRenderFns } from "./coach.vue?vue&type=template&id=2d4d372c&scoped=true"
import script from "./coach.vue?vue&type=script&lang=ts"
export * from "./coach.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4d372c",
  null
  
)

export default component.exports